// postCastingCallReducer.js

export const initialFormState = {
  contactName: "",
  company: "",
  contactPhone: "",
  contactEmail: "",
  projectName: "",
  projectDescription: "",
  auditionLocations: [],
  castingOrShootDatesInfo: "",
  payScale: "",
  paymentType: "", 
  mediaUpload: null,
  expirationDate: "",
unionStatus: [],
  projectTitle: "",
  removalDate: "",
  PicturesFile: null,
  PicturesFileName: "",
  ScriptsFile: null,
  ScriptsFileName: "",
  jobCategories: [],
  removePicturesFile: false,
  removeScriptsFile: false,
};

export function formReducer(state, action) {
  switch (action.type) {
    case "UPDATE_FIELD":
      return {
        ...state,
        [action.field]: action.value,
      };

    case "SET_MULTIPLE_FIELDS":
      return {
        ...state,
        ...action.payload,
      };

    case "REMOVE_FILE":
      return {
        ...state,
        [action.field]: null,
        [action.nameField]: "",
      };
case "MARK_FILE_REMOVED":
  return {
    ...state,
    [action.field]: null,
    [action.nameField]: "",
    [action.removalFlag]: true,
  };
    case "RESET_FORM":
      return initialFormState;

    default:
      return state;
  }
}
